type Args = {
  exactConfig: string;
  doorType: string;
  sillStyle: string;
  netHeight: number;
  screenType: string;
  material: string;
  isPico: boolean;
  swingDirection?: string;
  fullboundProfile?: string;
  alumThickFrame?: boolean;
};

function calculatePanelHeight(panelArgs: Args) {
  const {
    doorType,
    exactConfig,
    sillStyle,
    netHeight,
    screenType,
    material,
    isPico,
  } = panelArgs;

  var panelHeight = 0;

  if (doorType === "Pivot") {
    panelHeight = netHeight - 1.9375;
  } else if (doorType === "Fixed Panel") {
    if (material === "All Aluminum") {
      if (exactConfig === "Direct Glaze") {
        panelHeight = netHeight - 0;
      } else {
        if (panelArgs.fullboundProfile === "Window Profile") {
          panelHeight = netHeight - 1.53125;
        } else {
          panelHeight = netHeight - 2.28125;
        }
      }
    } else if (exactConfig === "Fixed Bi-fold") {
      panelHeight = netHeight - 2 - 0.3125 - 0.3125 - 0.9375;
    } else if (exactConfig === "Fixed Slider") {
      panelHeight = netHeight - 2;
    } else if (exactConfig === "Fixed Full Bound") {
      panelHeight = netHeight - 1.75;
    } else if (exactConfig === "Fixed Inswing") {
      const jambLeg = material === "All Wood" ? 2 : 2.0625;
      panelHeight = netHeight - jambLeg;
    } else if (exactConfig === "Fixed Outswing") {
      panelHeight = netHeight - 1.5;
    }
  } else if (doorType.includes("Bi-fold")) {
    if (material === "All Aluminum") {
      const sillSub = sillStyle === "Embedded Sill" ? 0.7874 : 0;
      const subCentor = screenType?.includes("Centor") ? 1.4375 : 0;
      return netHeight - 1.5945 - 1.5945 + sillSub - subCentor;
    }

    const sub = screenType?.includes("Centor") ? 3.25 : 2;
    const panelH = netHeight - sub - 0.3125;

    if (sillStyle !== "Ultra Guide" && sillStyle !== "ADA Ultra Guide") {
      panelHeight = panelH - 0.3125 - 0.9375;
    } else if (
      sillStyle &&
      (sillStyle === "Ultra Guide" || sillStyle === "ADA Ultra Guide")
    ) {
      panelHeight = panelH - 0.4375;
    }
  } else if (doorType === "Swing") {
    const sub = screenType?.includes("Centor") ? 2.5 : 0;

    if (!isPico) {
      if (material === "All Aluminum") {
        if (panelArgs.alumThickFrame) {
          if (sillStyle?.includes("Flat")) {
            panelHeight =
              panelArgs.swingDirection === "Outswing"
                ? netHeight - 1.657188 - sub
                : netHeight - 1.657513;
          } else {
            panelHeight =
              panelArgs.swingDirection === "Outswing"
                ? netHeight - 1.440935 - sub
                : netHeight - 1.438924;
          }
        } else {
          if (sillStyle?.includes("Flat")) {
            panelHeight =
              panelArgs.swingDirection === "Outswing"
                ? netHeight - 1.2832 - sub //thin frame
                : netHeight - 1.2832;
          } else {
            panelHeight =
              panelArgs.swingDirection === "Outswing"
                ? netHeight - 1.06481 - sub //thin frame
                : netHeight - 1.0646;
          }
        }
      } else {
        const inswingSub = material === "All Wood" ? 2.0937 : 2.2812;

        panelHeight =
          panelArgs.swingDirection === "Outswing"
            ? netHeight - sub - 1.75
            : panelArgs.swingDirection === "Inswing"
              ? netHeight - inswingSub
              : 0;
      }
    } else {
      const swingDirection = panelArgs.swingDirection;
      if (swingDirection === "Outswing") {
        //Top Jamb: 0.875 (7/8)
        //Top Jamb Gap: 0.1562 (5/32)
        //Bottom Jamb: 0.625 (5/8)
        //Bottom Jamb Gap: 0.125 (1/8)
        //Total: 1.7812
        panelHeight = netHeight - 1.7812;
      } else if (panelArgs.swingDirection === "Inswing") {
        //Top Jamb: 0.9375 (15/16)
        //Top Jamb Gap: 0.0937 (3/32)
        //Bottom Jamb: 0.125 (1/8)
        //Bottom Jamb Gap: 1.125 (1 1/8)
        //Total For Inswing: 2.2812
        panelHeight = netHeight - 2.2812;
      } else {
        panelHeight = 0;
      }
    }
  } else if (doorType === "Slider") {
    const sub = screenType?.includes("Centor") ? 3.125 : 0;
    const panelH = netHeight - sub - 0.875 - 0.25 - 0.25;

    if (sillStyle !== "Raised SILLution") {
      panelHeight = panelH;
    } else if (sillStyle === "Raised SILLution") {
      panelHeight = panelH - 1;
    } else {
      panelHeight = panelH;
    }
  }

  return panelHeight;
}

export { calculatePanelHeight };
